<template>
  <div style="display: inline">
    <div v-if="history.length > 0">
      <h3>Historia ofert:</h3>
      <div v-for="(historyItem, index) of history" :key="historyItem.id">
        <b>Oferta {{ index + 1 }}</b> <br />
        Utworzył: <b>{{ historyItem.created_by_name }}</b> dnia <b>{{ historyItem.created_at }}</b> <br />
        Ostatnia edycja: <b>{{ historyItem.last_edit_by_name }}</b> dnia <b>{{ historyItem.last_edit_at }}</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminOfferHistory",
  props: {
    serviceOffer: { required: true, type: Array }
  },
  computed: {
    history() {
      let history = [];
      for (let itemServiceOffer of this.serviceOffer) {
        if (typeof itemServiceOffer.created_at !== "undefined") {
          history.push({
            id: itemServiceOffer.id,
            created_at: itemServiceOffer.created_at,
            created_by_name: itemServiceOffer.created_by_name,
            last_edit_at: itemServiceOffer.last_edit_at,
            last_edit_by_name: itemServiceOffer.last_edit_by_name
          });
        }
      }
      return history;
    }
  }
};
</script>

<style scoped></style>
